<template>
  <v-row no-gutters>
    <v-col class="pa-0">
      <VSelectAll
        label="Izaberite Poi-e"
        :items="initialPoisAdapted"
        v-model="selectedPois"
      ></VSelectAll>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from '@/store/store'
import httpClient from '../../../api/httpClient'
import VSelectAll from '../../custom/VSelectAll'

export default {
  name: 'RealTimePoiFilterComponent',
  components: {
    VSelectAll
  },
  data() {
    return {
      selectedPois: [],
      allPois: []
    }
  },
  computed: {
    ...mapState('map', ['initialPois', 'vehicles', 'realTimeRoutes']),
    ...mapGetters('filters', ['getFilterFunction']),
    initialPoisAdapted() {
      let data = []
      this.initialPois.forEach(x => {
        let obj = { value: x.id, text: x.name }
        if (!data.some(i => i.name == obj.name && i.text == obj.text)) {
          data.push(obj)
        }
      })
      return data
    }
  },
  mounted() {
    httpClient.get('/pois').then(result => {
      this.allPois = result.data
    })
  },
  watch: {
    selectedPois: {
      handler() {
        store.dispatch('filters/setSelectedPois', this.selectedPois)
        this.getFilterFunction.forEach(fnc => {
          fnc(this.vehicles, this.realTimeRoutes)
        })

        store.dispatch('map/clearPois')

        if (this.selectedPois.length) {
          this.selectedPois.forEach(spoi => {
            let poiToShow = this.allPois.filter(x => x.id == spoi)[0]
            store.dispatch('map/addPoi', poiToShow)
          })
        }
      }
    }
  }
}
</script>
